import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { userState } from "./store/user";
import Login from "./components/Login";
import Gallery from "./components/gallery/Gallery";
import Battles from "./components/battles/Battles";
import Votes from "./components/votes/Votes";
import Wallet from "./components/wallet/Wallet";
import Notifications from "./components/notifications/Notifications";
import BottomNav from "./components/Layout/BottomNav";
import NotificationsIcon from "./components/Layout/NotificationsIcon";
import Vote from "./components/votes/Vote";
import LeaderBoard from "./components/leaderboard/LeaderBoard";
import Upload from "./components/upload/Upload";
import Image from "./components/image/Image";
import StartBattle from "./components/battle/StartBattle";
import { useState } from "react";
import GlobalAppLoading from "./components/UI/GlobalAppLoading";
import NFT from "./components/image/NFT";
import ImagePopup from "./components/image/ImagePopup";
import Topics from "./components/topics/Topics";
import TopicsLeaderBoard from "./components/topics/TopicLeaderboard";
import { getLang, i18n } from "./i18n";

function App() {
  const lang = getLang();
  const t = i18n.loading[lang];

  const user = useSelector(userState);
  const [isLoading, setIsLoading] = useState(true);
  const [popupImage, setPopupImage] = useState("");
  const [notificationsCount, setNotificationsCount] = useState(0);
  return (
    <main>
      {isLoading && <GlobalAppLoading text={t.defaultText} />}
      {user.isLoggedIn && (
        <BrowserRouter>
          <NotificationsIcon
            notificationsCount={notificationsCount}
            setNotificationsCount={setNotificationsCount}
          />
          <ImagePopup popupImageID={popupImage} setPopupImage={setPopupImage} />
          <Routes>
            <Route index element={<Gallery setPopupImage={setPopupImage} />} />
            <Route path="upload" element={<Upload />} />
            <Route
              path="image"
              element={<Image setPopupImage={setPopupImage} />}
            />
            <Route path="nft" element={<NFT />} />
            <Route path="battle" element={<StartBattle />} />
            <Route
              path="battles"
              element={<Battles setPopupImage={setPopupImage} />}
            />
            <Route path="quizzes" element={<Topics />} />
            <Route
              path="quiz"
              element={<TopicsLeaderBoard setPopupImage={setPopupImage} />}
            />
            <Route path="votes" element={<Votes />} />
            <Route
              path="wallet"
              element={<Wallet setPopupImage={setPopupImage} />}
            />
            <Route
              path="leaderboard"
              element={<LeaderBoard setPopupImage={setPopupImage} />}
            />
            <Route
              path="notifications"
              element={
                <Notifications
                  setPopupImage={setPopupImage}
                  setNotificationsCount={setNotificationsCount}
                />
              }
            />
            <Route path="vote" element={<Vote />} />
          </Routes>
          <BottomNav />
        </BrowserRouter>
      )}
      {!user.isLoggedIn && <Login setIsLoading={setIsLoading} />}
    </main>
  );
}

export default App;
